export enum SPLIT_BTN_KINDS {
  PRIMARY_APP = 'primary-app',
  PRIMARY_WEB = 'primary-web',
  SECONDARY = 'secondary',
}

export enum SPLIT_BTN_SIZES {
  LARGE = 'large',
  MEDIUM = 'medium',
  SMALL = 'small',
}

export enum SPLIIT_BTN_ICON_POSITION {
  LEFT = 'left',
  RIGHT = 'right',
}
